module.exports = __webpack_public_path__ + "img/quality@2x.575b411.webp";